import { render } from "./OrdenacaoBusca.vue?vue&type=template&id=36a5725a&scoped=true&ts=true"
import script from "./OrdenacaoBusca.vue?vue&type=script&lang=ts"
export * from "./OrdenacaoBusca.vue?vue&type=script&lang=ts"

import "./OrdenacaoBusca.vue?vue&type=style&index=0&id=36a5725a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a5725a"]])

export default __exports__